import React from "react";
import { Flex, HStack, VStack, Text, Box, Heading, Grid, GridItem, Image, chakra } from "@chakra-ui/react";
import { useLoginSkolFederationen } from "./hooks";
import { useTranslation } from "react-i18next";
import bastadIcon from "assets/images/bastad-icon.png";
import helsingborgIcon from "assets/images/helsingborg-icon.png";
import avestaIcon from "assets/images/avesta-icon.png";
import { useHistory } from "react-router-dom";

const invalidCredentialsErrorMessage = "Inloggningen misslyckades";

export const LoginSkolFederationen = () => {
  const { handleLogin, authError } = useLoginSkolFederationen();
  const { t } = useTranslation();
  const history = useHistory();
  const municipalities = [
    {
      label: "Helsingborg",
      icon: helsingborgIcon,
      onClick: () => handleLogin("urn:ticket.siriusit.net:helsingborg_skolfed_anst"),
      disabled: false,
    },
    {
      label: "Båstad",
      icon: bastadIcon,
      onClick: () => handleLogin("https://access.bastad.se/nidp/saml2/metadata"),
      disabled: false,
    },
    {
      label: "Avesta",
      icon: avestaIcon,
      onClick: () => history.push("/login/avesta"),
      disabled: false,
    },
  ];

  const LoginBox = chakra(Box, {
    baseStyle: {
      borderRadius: "5%",
      position: "absolute",
      zIndex: 0,
      left: "50%",
      top: "40%",
      transform: "translate(-50%, -50%)",
      width: "450px",
    },
  });
  const LoginHeading = chakra(Heading, {
    baseStyle: {
      fontSize: "22",
      fontWeight: "semibold",
      lineHeight: "1.6",
      mt: 10,
      mb: 5,
      alignSelf: "center",
      color: "white",
      textAlign: "center",
    },
  });

  return (
    <Flex w="100vw" h="100vh" justifyContent="center" alignItems="center">
      <LoginBox>
        <VStack w="full" alignItems="stretch">
          <LoginHeading as="h1">{t("Login_SSO_Title")}</LoginHeading>
          <Flex wrap="wrap" justifyContent={municipalities.length <= 3 ? "space-around" : "center"} gap="10">
            {municipalities.map(
              (municipality, index) =>
                !municipality.disabled && (
                  <Box key={index} cursor="pointer" onClick={municipality.onClick} width="25%" mb="10">
                    <Image src={municipality.icon} alt={municipality.label} />
                    <Text color="white" textAlign="center" mt="2">
                      {municipality.label}
                    </Text>
                  </Box>
                ),
            )}
          </Flex>

          {authError && (
            <HStack w="full" justifyContent="center" pt="4">
              <Text fontWeight="light" color="white">
                {invalidCredentialsErrorMessage}
              </Text>
            </HStack>
          )}
        </VStack>
      </LoginBox>
    </Flex>
  );
};
